var render, staticRenderFns
import script from "./AxDialog.vue?vue&type=script&lang=ts&"
export * from "./AxDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AxDialog.vue?vue&type=style&index=0&id=21d10062&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports